import type { UserSetting } from '@axiom/validation';

import { PreloadedUserStore } from '../stores/preloaded-user-store';
import { UserSettingApi } from '../api/user-setting-api';
import { UserApi } from '../api/user-api';

export const UserSettingsUtil = {
  shouldShowNewOpportunityTalentView: (settings: UserSetting[] = []) =>
    !settings.some(
      s => s.name === 'show-new-opportunity-talent-view' && s.value === 'false'
    ),
  updateShowNewOpportunityTalentViewSetting: async (value: boolean) => {
    await UserSettingApi.updateUserSetting({
      name: 'show-new-opportunity-talent-view',
      value: value.toString(),
    });

    void PreloadedUserStore.load();
    // getUserMe is schema-wired but its `settings` are embedded (non-entity)
    // data, so a UserSetting write won't propagate automatically — invalidate
    // the settingsInfo read explicitly to refresh the session view.
    await UserApi.invalidate('/user/me/settingsInfo');
  },
};
